import { useNavigate } from "react-router-dom";
import "../css/InvoiceTable.css";
import { ADD_ICON } from "../../cufront-assets/icons/Icons";
import {
  CREDIT_INVOICE,
  INSTITUTION,
  INVOICE_STATUS,
  INVOICE_TYPE,
} from "../constants/_constant";
import { useEffect, useRef, useState } from "react";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import moment from "moment";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { toast } from "react-toastify";
import BillingEmail from "../components/BillingEmail";
import CuModal from "../../common_component/component/CuModal";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import PaginationComponent from "../../common_component/component/PaginationComponent";
import { Popup } from "semantic-ui-react";
import CuDropdown from "../../common_component/component/CuDropdown";
import FilterDropdown from "../../common_component/component/FilterDropdown";
import CuInput from "../../all-patient/components/CuInput";
import { RiEdit2Fill } from "react-icons/ri";
import { IoEyeSharp } from "react-icons/io5";
import { CiSquareChevLeft } from "react-icons/ci";
import { CiSquareChevRight } from "react-icons/ci";
import CuButton from "../../all-patient/components/CuButton";
import PrintAllInvoices from "../../doctor_setup/views/PrintAllInvoices";
import { useReactToPrint } from "react-to-print";
import { BsFillPrinterFill } from "react-icons/bs";
import { getCurrentDate, sumByKey } from "../../_helper/utils/utils";

const InvoiceTable = () => {
  const navigate = useNavigate();
  const printRef = useRef(null); // Create a ref to target PrintInvoiceSummary
  // const [isGrid, setIsGrid] = useState(true);
  const initialFilters = JSON.parse(
    localStorage.getItem("invoice_filters")
  ) || {
    type: ["OPD"],
    status: ["draft"],
    institution: "true",
    payment_type: [],
  };
  const [filter, setFilter] = useState(initialFilters);
  const [tableData, setTableData] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [isFilterModal, setIsFilterModal] = useState(false);
  const [isDownload, setIsdownload] = useState(false);
  const [isStats, setIsStats] = useState(false);
  const [clinic] = useAtom(clinicAtom);
  const [searchInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageLimit, setPerPageLimit] = useState(25);
  const [dayCycle, setDayCycle] = useState("All");
  const [dateRange, setDateRange] = useState("");
  const [isJumpDate, setIsJumpDate] = useState(false);
  const [customDateFilter, setCustomDateFilter] = useState({
    startDate: "",
    endDate: "",
  });

  const searchQuery = searchInput?.length > 0 ? `&search=${searchInput}` : "";

  const { data: getAllClinicDoctors } = useItemsFilter(
    ApiEndPoint.CLINIC,
    `?action=getClinicDoctor&clinic_id=${clinic.id}&id=${clinic.id}`
  );

  const { data: PAYMENT_TYPE } = useItemsFilter(
    ApiEndPoint.PAYMENTS_BILLING,
    `?action=getPaymentOptions&clinic_id=${clinic.id}`
  );

  const handleBillTypeClick = (type) => {
    navigate(`/new/create_invoice?bill_type=${type}`);
  };

  let dateFilter = "";

  const dateFilterQuery =
    customDateFilter?.startDate && customDateFilter?.endDate
      ? `&date=${moment(customDateFilter?.startDate).format("YYYY-MM-DDTHH:mm:ss[Z]")}to${moment(customDateFilter?.endDate).format("YYYY-MM-DDTHH:mm:ss[Z]")}`
      : "";

  if (dayCycle === "Day") {
    dateFilter = `&date=${moment(dateRange, "D MMM YY").format("YYYY-MM-DDTHH:mm:ss[Z]")}`;
  }

  if (dayCycle === "Week") {
    const selectedWeek = dateRange.split("-");
    if (selectedWeek?.length > 1) {
      const startOfWeek = moment(selectedWeek[0], "D MMM YY").format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      );
      const endOfWeek = moment(selectedWeek[1], "D MMM YY").format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      );
      dateFilter = `&date=${startOfWeek}to${endOfWeek}`;
    }
  }

  if (dayCycle === "Month") {
    const parsedDate = moment(dateRange, "MMMM YY");
    const startOfMonth = parsedDate
      .startOf("month")
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    const endOfMonth = parsedDate
      .endOf("month")
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
    dateFilter = `&date=${startOfMonth}to${endOfMonth}`;
  }

  let queryParams = `?action=getBillingCreditInvoice&frontend=True&clinic_id=${clinic?.id}&bill_type=${filter?.type}&status=${filter?.status}`;

  // Only include doctor_id if it's defined
  if (filter.doctor_id !== undefined) {
    queryParams += `&doctor_id=${filter.doctor_id}`;
  }

  // Only include payment_type if it's defined
  if (filter.payment_type !== undefined) {
    queryParams += `&payment_type=${filter.payment_type}`;
  }

  queryParams += `&institution=${filter?.institution}&page=${currentPage}&records_number=${perPageLimit}${searchQuery}${dateFilterQuery}`;

  const { data: invoiceData, isLoading } = useItemsFilter(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    queryParams,
    clinic?.id ? true : false,
    "invoice"
  );

  const { data: invoiceStatistics } = useItemsFilter(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    `?action=getBillingCreditPayment&frontend=True&clinic_id=${clinic?.id}&statistics=True`,
    clinic?.id ? true : false
  );

  // Convert the doctors data into FilterDropdown options
  const DOCTOR_OPTIONS = getAllClinicDoctors?.map((doctor) => ({
    key: doctor.id,
    value: doctor.id,
    text: doctor.speciality
      ? `${doctor.first_name} ${doctor.last_name} (${doctor.speciality})`
      : `${doctor.first_name} ${doctor.last_name}`,
  }));

  const PAYMENT_OPTIONS = PAYMENT_TYPE?.map((p) => ({
    key: p.type,
    value: p.type,
    text: p.type,
  }));

  // console.log("Filter", filter);

  // Create a label for the received payment card based on payment_type filter
  const receivedPaymentLabel =
    filter?.payment_type?.length > 0
      ? `Received (${filter.payment_type.join(", ")})`
      : "Received";

  // Function to check if a row is selected
  const isRowSelected = (invoice) => {
    const selectedRow = selectedInvoices?.findIndex(
      (invc) => invc?.id === invoice
    );
    if (selectedRow > -1) {
      return true;
    } else {
      return false;
    }
  };

  const totalDataCount = invoiceData?.total_count;

  const totalPages = Math.ceil(totalDataCount / perPageLimit);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleGoToPage = (event) => {
    const page = parseInt(event.target.value);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleGoToPage(event);
    }
  };

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };
  const debouncedHandleSearch = debounce((query) => {
    if (query.length == 0) {
      setSearchInput("");
      return;
    }
    setSearchInput(query);
  }, 900);

  const handleSearch = (e) => {
    debouncedHandleSearch(e.target.value);
  };

  const total_amt = sumByKey(tableData, "invoice_total");
  const recived_amt = sumByKey(tableData, "recieved_payment");
  const pending_amt = sumByKey(tableData, "pending_payment");

  useEffect(() => {
    if (invoiceData?.data) {
      const tableData = invoiceData?.data?.map((invoice) => {
        let modifiedData;
        if (filter?.institution === "true") {
          modifiedData = {
            id: invoice?.id,
            customerId: invoice?.institution_customer?.id,
            invoice_number: invoice?.invoice_no,
            status: invoice?.status,
            type: invoice?.bill_type || "",
            customer: invoice?.institution_customer?.institution_name,
            due_date: invoice?.due_date,
            invoice_date: moment(invoice?.invoice_date).format("D MMMM YYYY"),
            invoice_total: Number(invoice?.invoice_total),
            invoice_pdf: invoice?.pdf_invoice,
            email: invoice?.institution_customer?.email_address,
            recieved_payment: invoice?.receive_payment,
            pending_payment: invoice?.pending_payment,
          };
        } else {
          modifiedData = {
            id: invoice?.id,
            customerId: invoice?.institution_customer?.id,
            invoice_number: invoice?.invoice_no,
            status: invoice?.status,
            type: invoice?.bill_type || "",
            visit_date: moment(invoice?.invoice_date).format("D MMMM YYYY"),
            invoice_total: Number(invoice?.invoice_total),
            invoice_pdf: invoice?.pdf_invoice,
            email: invoice?.institution_customer?.email_address,
            recieved_payment: invoice?.receive_payment,
            pending_payment: invoice?.pending_payment,
          };
        }
        return modifiedData;
      });
      setTableData(tableData);
    }
  }, [invoiceData?.data]);

  const handleAction = (id, type, billType) => {
    if (type === "edit") {
      // setAction({ id: id, edit: true, view: false });
      navigate(`/new/create_invoice?editId=${id}&bill_type=${billType}`);
    } else {
      // setAction({ id: id, edit: false, view: true });
      navigate(`/new/create_invoice?viewId=${id}&bill_type=${billType}`);
    }
  };

  const handleCustomerLink = (id) => {
    const selectedInvoice = invoiceData?.data?.find((inc) => inc?.id === id);
    if (selectedInvoice) {
      navigate(
        `/new/setup/customersetup?active=customerdetails&group_id=3&option_id=0&mode=view&id=${selectedInvoice?.institution_customer?.id}`
      );
    }
  };

  const handleFilter = (value, label) => {
    setFilter((prev) => ({ ...prev, [label]: value }));
  };

  // Set up the printing function with custom page size and styling
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Invoice Summary",
    onBeforeGetContent: () => {
      // Add styles dynamically if needed
      return new Promise((resolve) => {
        const style = document.createElement("style");
        style.innerHTML = `
          @page {
            size: A4; /* Change page size, e.g., A4, Letter */
            margin: 10mm;
          }
          @media print {
            body {
              -webkit-print-color-adjust: exact; /* Ensures colors are printed as seen */
            }
            .print-container {
              font-size: 14px;
              color: #333;
              /* Add any additional styles for print */
            }
          }
        `;
        document.head.appendChild(style);
        resolve();
      });
    },
  });

  const handleDayCycle = (cycle) => {
    setDayCycle(cycle);
    let result = "";

    switch (cycle) {
      case "Day":
        result = moment().format("D MMM YY");
        break;
      case "Week":
        const startOfWeek = moment().format("D MMM YY");
        const endOfWeek = moment().add(6, "days").format("D MMM YY");
        result = `${startOfWeek} - ${endOfWeek}`;
        break;
      case "Month":
        result = `${moment().format("MMMM YY")}`;
        break;
      default:
        result = "";
    }
    setDateRange(result);
  };

  const handleNext = () => {
    if (dayCycle === "Day") {
      setDateRange((prev) => {
        return moment(prev).add(1, "day").format("D MMM YY");
      });
    }
    if (dayCycle === "Week") {
      setDateRange((prev) => {
        const currentWeek = prev?.split("-");
        let result = prev;
        if (currentWeek?.length > 1) {
          const startOfWeek = moment(currentWeek[1]).format("D MMM YY");
          const endOfWeek = moment(startOfWeek)
            .add(6, "days")
            .format("D MMM YY");
          result = `${startOfWeek} - ${endOfWeek}`;
        }
        return result;
      });
    }
    if (dayCycle === "Month") {
      setDateRange((prev) => {
        const nextMonth = moment(prev, "MMMM YY")
          .add(1, "month")
          .format("MMMM YY");
        return nextMonth;
      });
    }
  };

  const handlePrev = () => {
    if (dayCycle === "Day") {
      setDateRange((prev) => {
        return moment(prev).subtract(1, "day").format("D MMM YY");
      });
    }
    if (dayCycle === "Week") {
      setDateRange((prev) => {
        const currentWeek = prev?.split("-");
        let result = prev;
        if (currentWeek?.length >= 1) {
          const startOfWeek = moment(currentWeek[0])
            .subtract(6, "days")
            .format("D MMM YY");
          const endOfWeek = moment(currentWeek[0]).format("D MMM YY");
          result = `${startOfWeek} - ${endOfWeek}`;
        }
        return result;
      });
    }
    if (dayCycle === "Month") {
      setDateRange((prev) => {
        const prevMonth = moment(prev, "MMMM YY")
          .subtract(1, "month")
          .format("MMMM YY");
        return prevMonth;
      });
    }
  };

  const handleJumpDate = () => {
    if (dayCycle === "Day") {
      setIsJumpDate(true);
    }
  };

  const handleDateChange = (e) => {
    if (dayCycle === "Day") {
      const date = e.target.value;
      const newDate = moment(date).format("D MMM YY");
      setDateRange(newDate);
      setIsJumpDate(false);
    }
  };

  useEffect(() => {
    if (filter) {
      localStorage.setItem("invoice_filters", JSON.stringify(filter));
    }
  }, [filter]);

  return (
    <>
      <div className="cu-invoice-table-container">
        <div className="cu-invoice-table-search">
          <div className="cu-invoice-table-icon">
            <Popup
              trigger={
                <div className="cu-invoice-table-create-icon">
                  <span>
                    <img src={ADD_ICON} alt="add icon" />
                  </span>
                  <span>Create Bill</span>
                </div>
              }
              content={
                <div className="flex flex-col gap-2">
                  <div
                    className="cursor-pointer hover:bg-[#0000000d] p-1"
                    onClick={() => handleBillTypeClick("OPD")}
                  >
                    Create OPD
                  </div>
                  <div
                    className="cursor-pointer hover:bg-[#0000000d] p-1"
                    onClick={() => handleBillTypeClick("IPD")}
                  >
                    Create IPD
                  </div>
                  <div
                    className="cursor-pointer hover:bg-[#0000000d] p-1"
                    onClick={() => handleBillTypeClick("PHARMACY")}
                  >
                    Create Pharmacy
                  </div>
                </div>
              }
              on={"click"}
              hoverable
            />
          </div>
          <div className="flex items-center gap-3">
            <div className="cu-invoice-table-search-input">
              <CuInput
                type="text"
                placeholder="Search"
                search={true}
                position="calc(50% + -10px)"
                onChange={(e) => handleSearch(e)}
                loading={isLoading}
              />
            </div>
            <div className="p-2">
              {/* Filters Button */}
              <CuButton
                onClick={() => setIsFilterModal(true)}
                className="bg-[#c7eac9] px-5 py-2 rounded-lg font-semibold"
              >
                <i className="fas fa-filter mr-2"></i>
              </CuButton>
            </div>
            <div className="p-2">
              {/* Filters Button */}
              <CuButton
                onClick={() => setIsdownload(true)}
                className="bg-[#c7eac9] px-5 py-2 rounded-lg font-semibold"
              >
                <i className="fas fa-download mr-2"></i>
              </CuButton>
            </div>
            <div className="p-2">
              {/* Filters Button */}
              <CuButton
                onClick={() => setIsStats(true)}
                className="bg-[#c7eac9] px-5 py-2 rounded-lg font-semibold"
              >
                <i className="fas fa-chart-line mr-2"></i>
              </CuButton>
            </div>
          </div>
        </div>

        {dayCycle !== "All" && (
          <div className="flex items-center justify-center gap-2">
            <CiSquareChevLeft
              size={30}
              className="cursor-pointer"
              onClick={handlePrev}
            />
            <span
              className="text-[18px] leading-[20px] text-[#000000] font-bold cursor-pointer"
              onClick={handleJumpDate}
            >
              {!isJumpDate && dateRange}
              {isJumpDate && (
                <input
                  type="date"
                  className="outline-none"
                  value={moment(dateRange).format("YYYY-MM-DD")}
                  onChange={handleDateChange}
                />
              )}
            </span>
            <CiSquareChevRight
              size={30}
              className="cursor-pointer"
              onClick={handleNext}
            />
          </div>
        )}
        {!isLoading && invoiceData?.data?.length === 0 && (
          <div>No data found</div>
        )}
        {tableData?.length > 0 && (
          <div className="cu-invoice-table">
            <table>
              <thead className="cu-invoice-table-header">
                <tr>
                  {/* <th className="pl-[10px]">Select</th> */}
                  {CREDIT_INVOICE?.tableCols?.map((col) => {
                    if (
                      col?.label !== "Diagnosis" &&
                      col?.label !== "Treatment"
                    ) {
                      if (filter?.institution === "true") {
                        return <th key={col?.id}>{col?.label}</th>;
                      } else {
                        if (
                          col?.label !== "Customer" &&
                          col?.label !== "Due Date"
                        ) {
                          return <th key={col?.id}>{col?.label}</th>;
                        }
                      }
                    }
                  })}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableData?.map((trow, i) => {
                  return (
                    <tr key={i}>
                      {Object.keys(trow)?.map((key, idx) => {
                        return (
                          key !== "id" &&
                          key !== "email" &&
                          key !== "invoice_pdf" &&
                          key !== "customerId" &&
                          (key === "invoice_number" ? (
                            <td
                              key={idx}
                              className="cursor-pointer text-[#4183c4]"
                              onClick={() =>
                                handleAction(trow?.id, "view", trow?.type)
                              }
                            >
                              {trow[key]}
                            </td>
                          ) : key === "customer" ? (
                            <td
                              key={idx}
                              className="cursor-pointer text-[#4183c4]"
                              onClick={() => handleCustomerLink(trow?.id)}
                            >
                              {trow[key]}
                            </td>
                          ) : (
                            <td key={idx}>{trow[key]}</td>
                          ))
                        );
                      })}
                      <td>
                        <div className="cu-invoice-table-action-col">
                          <RiEdit2Fill
                            size={18}
                            className="cursor-pointer"
                            color="#777777"
                            onClick={() =>
                              handleAction(trow?.id, "edit", trow?.type)
                            }
                          />
                          <IoEyeSharp
                            size={19}
                            className="cursor-pointer"
                            color="#777777"
                            onClick={() =>
                              handleAction(trow?.id, "edit", trow?.type)
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {isDownload && (
        <CuModal closeModal={setIsdownload} className="w-[50%] items-center">
          {/* Download Button */}
          <button
            onClick={handlePrint}
            className="flex float-end mb-2 items-center bg-blue-500 text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-200 ease-in-out shadow-md"
            onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
          >
            <BsFillPrinterFill className="mr-2" />
            Download/Print
          </button>

          <div ref={printRef} className="print-container">
            <PrintAllInvoices
              setIsSend={() => setIsdownload(false)}
              tableData={tableData}
              billDate={getCurrentDate()}
              CREDIT_INVOICE={CREDIT_INVOICE}
              filter={filter}
            />
          </div>
        </CuModal>
      )}
      {isStats && (
        <CuModal closeModal={setIsStats} className="items-center p-0">
          <div className="relative max-w-lg mx-auto bg-gradient-to-r from-purple-500 to-indigo-500 text-white shadow-lg rounded-lg p-8">
            {/* Close Icon */}
            <button
              onClick={() => setIsStats(false)}
              className="absolute top-4 right-4 text-white text-2xl font-bold focus:outline-none"
            >
              <i className="fas fa-times"></i> {/* Font Awesome Close Icon */}
            </button>

            <h2 className="text-2xl font-extrabold mb-6 text-center">
              Invoice Stats
            </h2>
            <div className="flex flex-col gap-6">
              {/* Total Amount */}
              <div className="flex items-center justify-between bg-white bg-opacity-10 p-4 rounded-lg shadow-md">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-purple-700 rounded-full">
                    <i className="fas fa-coins text-white text-xl"></i>
                  </div>
                  <span className="text-lg font-semibold">Total Amount</span>
                </div>
                <span className="text-xl font-bold">₹{total_amt}</span>
              </div>

              {/* Pending */}
              <div className="flex items-center justify-between bg-white bg-opacity-10 p-4 rounded-lg shadow-md">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-yellow-600 rounded-full">
                    <i className="fas fa-hourglass-half text-white text-xl"></i>
                  </div>
                  <span className="text-lg font-semibold">Pending</span>
                </div>
                <span className="text-xl font-bold">₹{pending_amt}</span>
              </div>

              {/* Received */}
              <div className="flex items-center justify-between bg-white bg-opacity-10 p-4 rounded-lg shadow-md">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-green-600 rounded-full">
                    <i className="fas fa-check-circle text-white text-xl"></i>
                  </div>
                  <span className="text-lg font-semibold">
                    {receivedPaymentLabel}
                  </span>
                </div>
                <span className="text-xl font-bold">₹{recived_amt}</span>
              </div>
            </div>
          </div>
        </CuModal>
      )}
      {isFilterModal && (
        <CuModal closeModal={() => setIsFilterModal(false)}>
          <div className="bg-white p-8 rounded-lg max-w-lg mx-auto shadow-2xl">
            <h3 className="text-xl font-bold text-gray-800 mb-6">Filters</h3>
            <div className="space-y-6">
              {/* Bill Type Filter */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Bill Type
                </label>
                <FilterDropdown
                  options={INVOICE_TYPE}
                  onChange={(val) => handleFilter(val, "type")}
                  value={filter?.type || ""}
                  placeholder="Select Bill Type"
                />
              </div>

              {/* Status Filter */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Status
                </label>
                <FilterDropdown
                  options={INVOICE_STATUS}
                  onChange={(val) => handleFilter(val, "status")}
                  value={filter?.status || ""}
                  placeholder="Select Status"
                />
              </div>

              {/* Institution Filter */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Institution
                </label>
                <CuDropdown
                  options={INSTITUTION}
                  onChange={(val) => handleFilter(val, "institution")}
                  value={filter?.institution}
                  placeholder="Select Institution"
                  style={{ height: "36px" }}
                />
              </div>

              {/* Payment Received Type Filter */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Payment Received Type
                </label>
                <FilterDropdown
                  options={PAYMENT_OPTIONS} // e.g., ['UPI', 'Cash', 'Card']
                  onChange={(val) => handleFilter(val, "payment_type")}
                  value={filter?.payment_type || ""}
                  placeholder="Select Payment Type"
                />
              </div>

              {/* Doctor Filter */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Select Doctor
                </label>
                <CuDropdown
                  options={DOCTOR_OPTIONS} // e.g., list of doctor names or IDs
                  onChange={(val) => handleFilter(val, "doctor_id")}
                  value={filter?.doctor_id || ""}
                  placeholder="Select Doctor"
                />
              </div>

              {/* Date Filters */}
              <div className="flex flex-col gap-4">
                <label className="text-sm font-medium text-gray-700">
                  Date Range
                </label>
                <div className="flex items-center gap-4">
                  <CuInput
                    type="date"
                    placeholder="From Date"
                    value={customDateFilter?.startDate}
                    onChange={(e) =>
                      setCustomDateFilter((prev) => ({
                        ...prev,
                        startDate: e.target.value,
                      }))
                    }
                    style={{ height: "36px" }}
                    className="w-full border border-gray-300 rounded-lg p-2 text-gray-700 focus:ring-2 focus:ring-blue-500"
                  />
                  <span className="text-gray-500">to</span>
                  <CuInput
                    type="date"
                    placeholder="To Date"
                    value={customDateFilter?.endDate}
                    onChange={(e) =>
                      setCustomDateFilter((prev) => ({
                        ...prev,
                        endDate: e.target.value,
                      }))
                    }
                    style={{ height: "36px" }}
                    className="w-full border border-gray-300 rounded-lg p-2 text-gray-700 focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              <div
                className="flex justify-end"
                onClick={() => {
                  setIsFilterModal(false);
                }}
              >
                <CuButton className="bg-[#c7eac9] px-5 py-2 rounded-lg font-semibold">
                  Apply
                </CuButton>
              </div>
            </div>
          </div>
        </CuModal>
      )}

      <div className="mt-3 mb-3 sm:mb-20">
        <PaginationComponent
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          handleKeyPress={handleKeyPress}
          perPageLimit={perPageLimit}
          setPerPageLimit={setPerPageLimit}
        />
      </div>
      {isLoading && searchInput?.length === 0 && <CuScreenLoader />}
    </>
  );
};

export default InvoiceTable;
